/**
 * @fileoverview RadioGroupRenderer.module.css
 * Styles for the RadioGroupRenderer component that displays a radio group.
 *
 * @example
 * // Basic usage with the RadioGroupRenderer component
 * import css from './RadioGroupRenderer.module.css'
 *
 * <div className={css.container}>
 *   <div className={css.item}>Option 1</div>
 *   <div className={css.item}>Option 2</div>
 *   <div className={css.item}>Option 3</div>
 * </div>
 */

.container {
    border: 1px solid var(--neutural400);
    border-radius: 0.75rem;
}

.item + .item {
    border-top: 1px solid var(--neutural400);
}

.item {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid transparent;
    padding: 1rem 0;
    transition: all 0.2s ease-out;
}

.item:hover,
.item:focus,
.item:active {
    z-index: 10;
    border: 1px solid var(--neutural900);
    border-color: var(--neutural900);
    border-radius: 12px;
    outline: 6px solid var(--indigo300);
}

.item:hover .radio-unselected,
.item:focus .radio-unselected {
    border-color: var(--neutural900);
}

.item:hover .label,
.item:focus .label,
.item:active .label {
    text-decoration: underline;
    cursor: pointer;
}

.input {
    visibility: hidden;
    width: 0;
    height: 0;
}

.radio-label {
    height: 24px;
    display: flex;
}

.radio-selected {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    padding: 0;
    border: 8px solid var(--indigo700);
    background-color: var(--neutural000);
    box-sizing: border-box;
    transition: all 0.2s ease-out;
}

.radio-unselected {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid var(--neutural400);
    background-color: var(--neutural000);
    box-sizing: border-box;
    transition: all 0.2s ease-out;
}

.label {
    cursor: pointer;
    text-underline-offset: 3px;
    padding-right: 0.5rem;
}

.radio {
    display: flex;
    padding-left: 1rem;
    margin-right: 0.75rem;
}

.error {
    outline: 6px solid var(--red300);
    border-color: var(--neutural900);
}

.errorMessage {
    padding-top: 1rem;
    color: var(--red700);
}
